module.exports = __webpack_public_path__ + "img/admin-homepage-interest-green.dda23d90.svg";